import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import DashboardNew from './pages/DashboardNew';
import SearchPage from './pages/SearchPage';
import DetailPage from './pages/DetailPage';
import ActivityPage from './pages/ActivityPage';
import WatchlistsPage from './pages/WatchlistsPage';
import TemasPage from './pages/TemasPage';
import ComparePage from './pages/ComparePage';
import SettingsPage from './pages/SettingsPage';
import MethodologyPage from './pages/MethodologyPage';
import AnalysisMonitorPage from './pages/AnalysisMonitorPage';
import './App.css';

function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [currentPage, setCurrentPage] = useState('dashboard');

  return (
    <div className="app-container">
      <Sidebar active={currentPage} onNavigate={setCurrentPage} />
      <main className="app-main">
        {children}
        <Footer />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/dashboard"
            element={
              <DashboardLayout>
                <DashboardNew />
              </DashboardLayout>
            }
          />
          <Route
            path="/search"
            element={
              <DashboardLayout>
                <SearchPage />
              </DashboardLayout>
            }
          />
          <Route
            path="/detail/:id"
            element={
              <DashboardLayout>
                <DetailPage />
              </DashboardLayout>
            }
          />
          <Route
            path="/activity"
            element={
              <DashboardLayout>
                <ActivityPage />
              </DashboardLayout>
            }
          />
          <Route
            path="/watchlists"
            element={
              <DashboardLayout>
                <WatchlistsPage />
              </DashboardLayout>
            }
          />
          <Route
            path="/themes"
            element={
              <DashboardLayout>
                <TemasPage />
              </DashboardLayout>
            }
          />
          <Route
            path="/compare"
            element={
              <DashboardLayout>
                <ComparePage />
              </DashboardLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <DashboardLayout>
                <SettingsPage />
              </DashboardLayout>
            }
          />
          <Route path="/metodologia" element={<MethodologyPage />} />
          <Route
            path="/admin/analyses"
            element={
              <DashboardLayout>
                <AnalysisMonitorPage />
              </DashboardLayout>
            }
          />
        </Routes>
      </Router>
      <Analytics />
    </>
  );
}
